<section>
    <p-dialog [(visible)]="displayDialog" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true"
        [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '50vw'}">

        <ng-template pTemplate="header">
            <CustomTitle [title]="headerText" />
        </ng-template>

        <ng-template pTemplate="content">
            <main class="grid formgrid p-fluid">
                <div class="field col-12">
                    <p-dropdown [options]="dataset" appendTo="body" autoWidth="false" [style]="{'width':'100%'}" [(ngModel)]="selectedValue"
                      [placeholder]="translations.seleccionar + '...'" [optionLabel]="categoryField" [showClear]="true">
                    </p-dropdown>
                </div>
            </main>
        </ng-template>

        <ng-template pTemplate="footer">
            <div class="field col-12">
                <div class="flex justify-content-between">
                    <button pButton type="button" [label]="translations.cancelar"  (click)="handleCancelar()"></button>
                    <button pButton type="button" [label]="translations.seleccionar"  (click)="handleSeleccionar()"></button>
                </div>
            </div>
        </ng-template>
    </p-dialog>
</section>
